import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { AbsoluteSpinner } from '@components/core-ui/spinners/Spinner';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { useAPI } from '@providers/useAPI';
import { useAuthContext } from '@providers/AuthProvider';
import { WorkspacesService } from 'app/API';
import { TWorkspace } from 'app/types/entities/TWorkspace';
import { useState } from 'react';

type TProps = {
  workspace: TWorkspace;
  onCancel: () => void;
  onSuccess: () => void;
};

export const DeleteWorkspaceModal = ({ workspace, onCancel, onSuccess }: TProps) => {
  const { call } = useAPI();
  const { removeWorkspace } = useAuthContext();
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const deleteHandler = async () => {
    setIsSubmitting(true);
    const data = await call(WorkspacesService.deleteWs({ wsid: workspace.id }));
    if (!data.error) {
      removeWorkspace(workspace.id);
      onSuccess();
    } else {
      setError(data.error);
    }
    setIsSubmitting(false);
  };

  return (
    <ModalWrapper width="330px">
      {isSubmitting ? <AbsoluteSpinner overlay={true} /> : null}
      <ModalTitle>Confirm</ModalTitle>
      <div className="text-center">Are you sure you want to delete {workspace.name} workspace?</div>
      {error && <div className="-mt-5 text-center text-[10px] font-medium text-[#ff2f2f]">{error}</div>}
      <div className="flex justify-between">
        <OutlinedButton onClick={onCancel} style={{ width: '130px' }}>
          Cancel
        </OutlinedButton>
        <Button onClick={deleteHandler} style={{ width: '130px' }}>
          Delete
        </Button>
      </div>
    </ModalWrapper>
  );
};
